<template>
  <form @submit.prevent="save_event" class="mt-8">

    <memlist-inline-alert variant="warning">
      Notera: Bilderna som kan laddas upp är för framtida evenemangslistan som ej är i drift. 
    </memlist-inline-alert>

    <p class="mt-4" style="font-weight: bold;">Listningsbild</p>
    <div class="d-flex">
      <div v-if="sm_preview_url || local_item.image_sm" style="width: 25%; max-height: 130px; overflow:hidden;">
        <img
          :src="sm_preview_url || ('data:image/png;base64,' + local_item.image_sm)"
          alt="Preview"
          style="width: 100%;"
        />
      </div>
      <div :style="{ width: (sm_preview_url || local_item.image_sm) ? '75%' : '100%' }">
        <memlist-image-dropzone-upload
          v-model="local_item.image_sm_file_id"
          :base64_preview="local_item.image_sm"
          @uploaded="on_image_sm_uploaded"
        />
      </div>
    </div>


    <p class="mt-4" style="font-weight: bold;">Fokusbild (stor bild) (frivilligt)</p>
    <div class="d-flex">
      <div v-if="xl_preview_url || local_item.image_xl" style="width: 25%; max-height: 130px; overflow:hidden;">
        <img
          :src="xl_preview_url || ('data:image/png;base64,' + local_item.image_xl)"
          alt="Preview"
          style="width: 100%;"
        />
      </div>
      <div :style="{ width: (xl_preview_url || local_item.image_xl) ? '75%' : '100%' }">
        <memlist-image-dropzone-upload
          v-model="local_item.image_xl_file_id"
          :base64_preview="local_item.image_xl"
          @uploaded="on_image_xl_uploaded"
        />
      </div>
    </div>

    <memlist-text-input
      id="facebook_url"
      name="facebook_url"
      :title="$t('EVENT.FACEBOOK_URL')"
      layout="vertical"
      validation_type="TEXT"
      v-model="local_item.facebook_url"
      @input="on_change"
    />

    <memlist-text-input
      id="x_url"
      name="x_url"
      :title="$t('EVENT.X_URL')"
      layout="vertical"
      validation_type="TEXT"
      v-model="local_item.x_url"
      @input="on_change"
    />

    <memlist-text-input
      id="instagram_url"
      name="instagram_url"
      :title="$t('EVENT.INSTAGRAM_URL')"
      layout="vertical"
      validation_type="TEXT"
      v-model="local_item.instagram_url"
      @input="on_change"
    />


    <memlist-text-input
      id="youtube_url"
      name="youtube_url"
      :title="$t('EVENT.YOUTUBE_URL')"
      layout="vertical"
      validation_type="TEXT"
      v-model="local_item.youtube_url"
      @input="on_change"
    />

    <memlist-text-input
      id="linkedin_url"
      name="linkedin_url"
      :title="$t('EVENT.LINKEDIN_URL')"
      layout="vertical"
      validation_type="TEXT"
      v-model="local_item.linkedin_url"
      @input="on_change"
    />

  </form>
</template>

<script>
export default {
  props: ['item'],
  watch: {
    
    item: {
      deep: true, // check properties of the form, not just the form reference (example.name for example)
      handler(val) {
        this.local_item = JSON.parse(JSON.stringify(this.item));
      },
      immediate: true
    },

  },
  methods: {
    on_image_xl_uploaded(file) {
      this.local_item.image_xl_file_id = file.file_id;
      this.xl_preview_url = file.public_path;

      this.$emit('change', this.local_item);
    },
    on_image_sm_uploaded(file) {
      this.local_item.image_sm_file_id = file.file_id;
      this.sm_preview_url = file.public_path;

      this.$emit('change', this.local_item);
    },
    save_event() {},
    on_change() {
      console.log('form has changed', this.local_item)
      this.$emit('change', this.local_item);
    }
  },
  data() {
    return {
      sm_preview_url: null,
      xl_preview_url: null,
      local_item: {}
    }
  },
}
</script>
<style scoped>
.preview img {
  width: 320px;
}
</style>